module.exports = __webpack_public_path__ + "static/65invgde-dc3c9ef5d2482e44376e088a4adfeebb.gif";